'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useMemo } from 'react';
import { ROUTES, STORAGE_KEY } from '@/constants';
import { hasInPageStepHistoryEntry } from '@/hooks/inPageStepHistory';
import { clearOverlayHistoryEntry, hasOverlayHistoryEntry, popOverlayHistoryEntry } from '@/hooks/useOverlayHistory';
import { useHistoryStore } from '@/stores/HistoryStore/useHistoryStore';
import { closeResponsiveDialog } from '@/stores/ResponsiveDialogStore';
const NOT_ALLOW_BACK_ROUTE = [ROUTES.AUTH, ROUTES.EASY_CERTIFICATION, ROUTES.EASY_CERTIFICATION_CALLBACK, ROUTES.LOGIN, ROUTES.CROSS_DOMAIN_AUTH];
export const useCustomRouter = () => {
  const $ = _c(13);
  const router = useRouter();
  let push;
  let replace;
  if ($[0] !== router) {
    const navigateReplacing = (href, options) => {
      sessionStorage.setItem(STORAGE_KEY.REPLACE_MARK, "true");
      sessionStorage.setItem(STORAGE_KEY.REPLACE_MARK_KB, "true");
      return router.replace(href, options);
    };
    let t0;
    if ($[3] !== navigateReplacing) {
      t0 = (href_0, options_0) => {
        if (hasOverlayHistoryEntry()) {
          popOverlayHistoryEntry().then(() => {
            navigateReplacing(href_0, options_0);
          });
          return;
        }
        return navigateReplacing(href_0, options_0);
      };
      $[3] = navigateReplacing;
      $[4] = t0;
    } else {
      t0 = $[4];
    }
    replace = t0;
    push = (href_1, options_1) => {
      if (hasOverlayHistoryEntry()) {
        clearOverlayHistoryEntry();
        return navigateReplacing(href_1, options_1);
      }
      return router.push(href_1, options_1);
    };
    $[0] = router;
    $[1] = push;
    $[2] = replace;
  } else {
    push = $[1];
    replace = $[2];
  }
  let t0;
  if ($[5] !== replace || $[6] !== router) {
    t0 = t1 => {
      const fallbackHref = t1 === undefined ? ROUTES.HOME.pathname : t1;
      if (closeResponsiveDialog()) {
        return;
      }
      if (hasOverlayHistoryEntry()) {
        return router.back();
      }
      if (hasInPageStepHistoryEntry()) {
        return router.back();
      }
      const {
        historyIndex,
        customHistory
      } = useHistoryStore.getState();
      const isEmptyHistory = historyIndex < 1;
      const prevHistoryPath = customHistory.get(historyIndex - 1);
      const isNotAllowBackRoute = prevHistoryPath ? NOT_ALLOW_BACK_ROUTE.some(route => prevHistoryPath.includes(route.pathname)) : true;
      if (isEmptyHistory || isNotAllowBackRoute) {
        return replace(fallbackHref);
      }
      return router.back();
    };
    $[5] = replace;
    $[6] = router;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const back = t0;
  let t1;
  if ($[8] !== back || $[9] !== push || $[10] !== replace || $[11] !== router) {
    t1 = {
      ...router,
      push,
      replace,
      back
    };
    $[8] = back;
    $[9] = push;
    $[10] = replace;
    $[11] = router;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  const customRouter = t1;
  return customRouter;
};